import { render, staticRenderFns } from "./TimerControls.vue?vue&type=template&id=42ebb50a"
import script from "./TimerControls.vue?vue&type=script&lang=js"
export * from "./TimerControls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports